import { EnergySelection } from '@/models'

export interface EnergyState {
  energySelection: EnergySelection | null
}

export const InitialState: EnergyState = {
  energySelection: null,
}
